import React, { useState, useLayoutEffect } from 'react';
import { Editor } from 'primereact/editor';

import * as S from './styles';
import { color } from 'styles/pallete';

interface EditorTextChangeEvent {
	htmlValue: string | null;
	textValue: string;
	delta: any;
	source: string;
}

interface EditorQuillProps {
	onChange: any;
	value: string;
	title: string;
	heightEditor?: string;
	itemInEdit?: undefined | string;
}

export default function EditorQuill({
	onChange,
	value,
	title,
	heightEditor = '25vh',
	itemInEdit = undefined
}: EditorQuillProps) {
	const [text, setText] = useState(itemInEdit !== undefined ? itemInEdit : '');

	const onEditorStateChange = (e: any) => {
		setText(e.htmlValue === null ? '' : e.htmlValue);
		return onChange(e.htmlValue);
	};

	useLayoutEffect(() => {
		setText(value);
	}, [value]);

	useLayoutEffect(() => {
		if (itemInEdit !== undefined) {
			setText(itemInEdit);
		}
	}, [itemInEdit]);

	return (
		<S.container>
			{title && (
				<S.title>
					<p>{title}</p>
				</S.title>
			)}
			<S.boxEditor>
				<Editor
					value={text}
					onTextChange={(e: EditorTextChangeEvent) => {
						onEditorStateChange(e);
					}}
					style={{ height: heightEditor, color: color.interface.darkgray }}
				/>
			</S.boxEditor>
		</S.container>
	);
}
